module.exports = __webpack_public_path__ + "static/media/bop-hero.cb7fcdcd.jpg";